import { render, staticRenderFns } from "./Cpu.vue?vue&type=template&id=bb6e03e0&"
import script from "./Cpu.vue?vue&type=script&lang=js&"
export * from "./Cpu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports